export interface KRideProviderConfig {
  id: 'kride'
  displayName: string
  enabled: boolean
  appStartUrl: string
  fallbackUrl: string
  supportsDestinationPrefill: false
  campaignId: string | null
  attributionId: string | null
}

export type KRideProviderErrorCode = 'DISABLED' | 'INVALID_APP_START_URL'

export class KRideProviderError extends Error {
  constructor(readonly code: KRideProviderErrorCode) {
    super(code)
    this.name = 'KRideProviderError'
  }
}

function requireOfficialHttpsUrl(value: string): string {
  let url: URL
  try {
    url = new URL(value)
  } catch {
    throw new KRideProviderError('INVALID_APP_START_URL')
  }
  if (url.protocol !== 'https:' || !url.hostname.endsWith('.kakaomobility.com')) {
    throw new KRideProviderError('INVALID_APP_START_URL')
  }
  return url.toString()
}

/**
 * Publicly verified scope: open the official K-RIDE app-start service URL.
 * No destination, pickup, coordinate, fare, token, or attribution parameters
 * are invented or appended here.
 */
export class KRideProvider {
  readonly id = 'kride' as const

  constructor(readonly config: KRideProviderConfig) {}

  get displayName(): string {
    return this.config.displayName
  }

  get enabled(): boolean {
    return this.config.enabled
  }

  get supportsDestinationPrefill(): false {
    return this.config.supportsDestinationPrefill
  }

  buildAppStartUrl(): string {
    if (!this.enabled) throw new KRideProviderError('DISABLED')
    return requireOfficialHttpsUrl(this.config.appStartUrl)
  }

  openApp(): void {
    window.location.assign(this.buildAppStartUrl())
  }
}
